import { FormWithRedux } from '../../FormWithRedux';
import { GPChestPainPathwayInformationForm} from './GPChestPain-PathwayInformationForm';

export class GPChestPainIntroForm extends FormWithRedux {

    constructor() {
        super('introForm');
    }

    generateSubform(identifier) {
        switch (identifier) {
            case 'pathwayInformationForm':
                return new GPChestPainPathwayInformationForm();
        }
    }

    shouldDisplayFormDetailForIdentifier() {
        return true;
    }

    isEnabled(identifier) {
        if (identifier != null) {
            return true;
        }
        return false;
    }

    isMandatory() {
        return false;
    }

    getValueType() {
        return null;
    }

    submissionValidation() {
        return [];
    }

    detailString() {
        return this.detail;
    }
}


// WEBPACK FOOTER //
// ./src/forms/gpChestPain01/Forms/GPChestPain-IntroForm.js